<template>
  <v-dialog :model-value="dialog" @update:modelValue="(val) => emit('update:dialog', val)" width="40%" transition=""
    persistent :open-delay="0" :close-delay="0">
    <v-card>
      <v-card-title class="text-h6">
        <span>{{
          isEntryMode ? "Add Secondary Unit" : "Update Secondary Unit"
          }}</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form @submit.prevent="submit" ref="SecondaryUnitSetup">
          <v-row>
            <v-col cols="12">
              <v-autocomplete variant="outlined" density="compact" bg-color="grey-lighten-4"
                v-model="unit_id.value.value" :items="getUnitList.filter((item) => item.status == 1)" :item-title="(item) =>
                    item && item.name && item.code
                      ? `${item.name} - ${item.code}`
                      : ''
                  " item-value="id" :error-messages="unit_id.errorMessage.value" clearable>
                <template #label>
                  Primary Unit <span class="text-red-accent-4">*</span>
                </template>
              </v-autocomplete>

              <v-text-field label="Name" density="compact" variant="outlined" bg-color="grey-lighten-4"
                v-model="name.value.value" :error-messages="name.errorMessage.value" clearable>
                <template #label>
                  Name <span class="text-red-accent-4">*</span>
                </template>
              </v-text-field>

              <v-text-field label="Conversion Quantity" v-model="conversion_qty.value.value" type="number"
                density="compact" variant="outlined" bg-color="grey-lighten-4"
                :error-messages="conversion_qty.errorMessage.value">
                <template #label>
                  Conversion Quantity <span class="text-red-accent-4">*</span>
                </template>

              </v-text-field>

              <v-text-field label="Remarks (Optional)" density="compact" variant="outlined" bg-color="grey-lighten-4"
                v-model="remarks.value.value" :error-messages="remarks.errorMessage.value" clearable />
              <v-checkbox label="Active" v-model="status.value.value" :error-messages="status.errorMessage.value"
                density="compact" variant="outlined" hide-details single-line color="primary" value="1" />
              <input v-model="secondary_unit_id.value.value" type="hidden" />
            </v-col>
            <v-divider />
            <v-card-actions>
              <v-layout class="justify-end">
                <v-btn class="bg-red" variant="flat" type="reset" @click="closeDialog">Close</v-btn>
                <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                  {{ isEntryMode ? "Save" : "Update" }}
                </v-btn>
              </v-layout>
            </v-card-actions>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import { fileServerUrl } from "@/store/api";

export default {
  name: "SecondaryUnitSetup",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({
        name: "",
        code: "",
        conversion_qty: "",
        remarks: "",
        status: "1",
        unit_id: null,
        secondary_unit_id: null,
      }),
    },
  },
  data() {
    return {
      localDialog: this.dialog,
      errorMessages: "",
      loading: false,
      isEntryMode: true,
    };
  },
  computed: {
    getUnitList() {
      return this.$store.getters.getUnitList;
    },
  },
  watch: {
    dialog(val) {
      this.localDialog = val;
    },
    localDialog(val) {
      this.$emit("update:dialog", val);
    },
    data: {
      handler(newData) {
        this.isEntryMode = !newData.id;
        this.resetForm({ errors: {}, touched: {} });
        this.name.setValue(newData.name || "", false);
        this.remarks.setValue(newData.remarks || "", false);
        this.status.setValue(String(newData.status) || "1", false);
        this.unit_id.setValue(newData.unit_id || "", false);
        this.conversion_qty.setValue(newData.conversion_qty || "", false);
        this.secondary_unit_id.setValue(newData.id || "", false);
      },
    },
  },

  created() {
    this.$store.dispatch("getUnitList");
  },
  methods: {
    updateDialog(val) {
      this.$emit("update:dialog", val);
    },
    closeDialog() {
      this.$emit("update:dialog", false);
    },
  },
  setup(props, { emit }) {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        name: yup.string().min(1).max(50).required().trim().label("Name"),
        remarks: yup.string().max(250).nullable().trim().label("Remarks"),
        unit_id: yup.string().min(1).max(10).required().trim().label("Unit"),
        conversion_qty: yup.number().typeError("Conversion Quantity must be a number").min(1).required().label("Conversion Quantity"),
      }),
    });

    const name = useField("name");
    const status = useField("status");
    const remarks = useField("remarks");
    const unit_id = useField("unit_id");
    const conversion_qty = useField("conversion_qty");
    const secondary_unit_id = useField("secondary_unit_id");
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();

    const submit = handleSubmit((values) => {
      console.log((values));
      store
        .dispatch("saveUpdateSecondaryUnit", values)
        .then((response) => {
          resetForm();
          emit("update:dialog", false);
          toast.success(response.data.message);
          loading.value = true;
          store
            .dispatch("getSecondaryUnitList")
            .then((data) => {
              loading.value = false;
            })
            .catch((error) => {
              loading.value = false;
              toast.error(error.response.data.message);
            });
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });
    return {
      submit,
      name,
      remarks,
      status,
      conversion_qty,
      unit_id,
      secondary_unit_id,
      errorMessages,
      resetForm,
      loading,
    };
  },
  mounted() { },
};
</script>
